import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const RefundIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "RefundGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.5447 21.9995C7.03048 21.9995 2.54468 17.5142 2.54468 12C2.54468 6.48581 7.03048 1.99951 12.5447 1.99951C18.0589 1.99951 22.5452 6.48482 22.5452 11.999C22.5452 17.5132 18.0589 21.9995 12.5447 21.9995ZM12.5447 3.00387C7.58464 3.00388 3.54904 7.03899 3.54904 11.999C3.54904 16.959 7.58465 20.9951 12.5447 20.9951C17.5052 20.9951 21.5408 16.96 21.5408 12C21.5408 7.03998 17.5052 3.00387 12.5447 3.00387Z"
        fill="#696969"
      />
      <path
        d="M16.6838 16.8335C16.5553 16.8335 16.4268 16.7845 16.3287 16.6864L8.05103 8.4092C7.85487 8.21304 7.85487 7.89524 8.05103 7.69908C8.24719 7.50292 8.56498 7.50292 8.76114 7.69908L17.0388 15.9763C17.235 16.1724 17.235 16.4902 17.0388 16.6864C16.9407 16.7845 16.8122 16.8335 16.6838 16.8335Z"
        fill="#696969"
      />
      <path
        d="M8.40609 16.8335C8.2776 16.8335 8.14912 16.7845 8.05103 16.6864C7.85487 16.4902 7.85487 16.1724 8.05103 15.9763L16.3287 7.69908C16.5249 7.50292 16.8427 7.50292 17.0388 7.69908C17.235 7.89524 17.235 8.21304 17.0388 8.4092L8.76114 16.6864C8.66306 16.7845 8.53458 16.8335 8.40609 16.8335Z"
        fill="#696969"
      />
    </svg>
  );
};

export default RefundIcon;
